import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: Arial, sans-serif;
  }
  .password-generator input[type="range"]::-webkit-slider-thumb {
    background-color: #8cc540;
    border: 2px solid #7a9b2a;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .password-generator input[type="range"]::-moz-range-thumb {
    background-color: #8cc540;
    border: 2px solid #7a9b2a;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .password-generator input[type="range"] {
    accent-color: #8cc540;
    width: 80%;
  }

  .password-generator {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  .password-generator input[type="text"] {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    font-size: 35px;
    transition: border-color 0.3sease;
    height: 60px !important;
    padding-left: 25px;
    padding-right: 6.5rem;
    border-bottom-width: 5px !important;
    border-radius: 23px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    line-height: normal;
    border: 3px solid;
  }

  .password-generator .controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    position: relative;
  }

  .password-generator .slider-container {
    display: flex;
    align-items: center;
    width: 60%;
    flex-direction: column;
  }

  .password-generator .passwordlabel {
    width: 80%;
    display: flex;
    align-items: center;
  }

  .password-generator .bottonsbyus {
    position: absolute;
    right: 0;
    border: none;
    margin: 10px;
    padding: 0;
    padding-bottom: 1px;
  }

  .password-generator .bottonsbyus button {
    height: 40px;
    width: 40px;
    font-size: 20px;
    color: #8cc540;
    background: none;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    padding: 8px;
    margin: 0 5px;
  }

  .password-generator .bottonsbyus button:hover {
    background-color: #f0f0f0;
  }

  .password-generator .password-status {
    font-size: 14px;
    margin-top: -14px;
    margin-left: 15px;
    text-align: left;
    padding: 0 20px;
    font-weight: 600;
    color: #555;
  }

  .password-generator .password-status.good {
    color: #2c9f45;
  }

  .password-generator .password-status.weak {
    color: #d9534f;
  }

  .password-generator .password-status.strong {
    color: #8cc540;
  }

  .password-generator .customize-your-password {
    margin-top: 20px;
    padding: 25px;
    border-radius: 20px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    background-color: white;
  }

  .password-generator .customize-your-password h3 {
    border-bottom: 1px solid #000;
    padding-bottom: 15px;
    color: #000;
    text-align: left;
    font-size: 48px;
    font-weight: 400;
    margin-bottom: 0 !important;
  }

  .password-generator .checkbox-slider {
    display: flex;
    align-items: center;
  }

  .password-generator .slider-container h5 {
    text-align: left;
    width: 80%;
    font-size: 18px;
    font-weight: 400;
    line-height: 38px;
    color: #58585a;
    margin: 0;
  }

  .password-generator .toggle-switch {
    display: inline-flex;
    align-items: center;
    position: relative;
    margin: 10px 0;
    cursor: pointer;
  }

  .password-generator .toggle-switch input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .password-generator .toggle-switch .slider {
    position: relative;
    min-width: 50px;
    width: 50px;
    height: 25px;
    background-color: #ccc;
    border-radius: 25px;
    transition: background-color 0.3s;
  }

  .password-generator .toggle-switch .slider::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: white;
    border-radius: 50%;
    top: 2.5px;
    left: 2.5px;
    transition: transform 0.3s;
  }

  .password-generator .toggle-switch input:checked + .slider {
    background-color: #8cc540;
  }

  .password-generator .toggle-switch input:checked + .slider::before {
    transform: translateX(25px);
  }

  .password-generator .toggle-switch label {
    padding-left: 10px;
    margin-bottom: 0;
    font-weight: 700;
  }

  .password-generator .checkbox-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 20px 0;
    text-align: start;
  }

  #passwordLengthCount {
    border: 1px solid #bbbbbb;
    font-size: 30px;
    margin-right: 20px;
    padding: 11px;
    border-radius: 5px;
  }

  #toggleHistory {
    margin-top: -40px;
    padding: 10px 20px;
    background-color: #8cc540;
    border: none;
    border-radius: 100px;
    cursor: pointer;
    color: #fff;
    font-size: 28px;
    font-weight: 600;
    height: 62px;
  }

  #toggleHistory:hover {
    background-color: #7a9b2a;
  }

  .password-generator .password-history {
    margin-top: 20px;
    max-height: 200px;
    overflow-y: auto;
    background-color: #f9f9f9;
    padding: 10px;
    border: 1px solid #ddd;
  }

  .password-generator .password-history h4 {
    font-size: 20px;
    margin-top: 20px;
  }

  .password-generator .password-history div {
    margin: 5px 0;
  }
  .heWi {
    height: 24px;
    width: 24px;
  }

  @media (max-width: 991px) {
    .heWi {
      height: 20px;
      width: 20px;
    }
    .password-generator .bottonsbyus button {
      padding: 5px;
      width: 22px;
    }
    .password-generator input[type="text"] {
      padding-right: 4.5rem;
    }
    .password-generator .customize-your-password h3 {
      font-size: 25px;
    }
    .password-generator .checkbox-slider {
      display: block;
    }
    .password-generator .slider-container {
      align-items: start;
      width: 100%;
    }
    #toggleHistory {
      font-size: 18px;
      height: 44px;
    }
  }
  @media (max-width: 400px) {
    .password-generator .customize-your-password h3 {
      font-size: 20px;
    }
  }
`;
